import {PropertyParentTuple, PropertyValue} from './PropertyPathWalker.js';
import {Sourceable} from '../option.js';
import { sourcesSymbol, typeSymbol, unAvailabilitySymbol } from '../engine-impl.js';
import { PModel } from '../engine.js';
import {TypeReference} from '../types.js';

export class ModelSystemProperties {

	public static getSource(propertyValue: PropertyValue): Sourceable | undefined {
		if(!propertyValue.parent!.value) {
			return;
		}
		if (!propertyValue.parent!.value[sourcesSymbol]) {
			propertyValue.parent!.value[sourcesSymbol] = {};
		}
		return propertyValue.parent!.value[sourcesSymbol][propertyValue.property.name];
	}
  public static getSourceFromModel(model: any, name: string): Sourceable | undefined {
    if (!model[sourcesSymbol]) {
      model[sourcesSymbol] = {};
    }
    return model[sourcesSymbol][name];
  }

	public static addSourceToModel(model: any, name: string, source: Sourceable): void {
		if (!model[sourcesSymbol]) {
			model[sourcesSymbol] = {};
		}
		model[sourcesSymbol][name] = source;
	}
	// public static setSource(propertyValue: PropertyValue, source: Sourceable): void {
	// 	if (!propertyValue.parent!.value[sourcesSymbol]) {
	// 		propertyValue.parent!.value[sourcesSymbol] = {};
	// 	}
	// 	propertyValue.parent!.value[sourcesSymbol][propertyValue.property.name] = source;
	// }

	public static getUnAvailablity(propertyParentTuple: PropertyParentTuple) : {[k:string]: any} {
		if(!propertyParentTuple.parent!.value) {
			return {};
		}
		if(!propertyParentTuple.parent!.value[unAvailabilitySymbol]) {
			propertyParentTuple.parent!.value[unAvailabilitySymbol] = {}
		}
		return propertyParentTuple.parent!.value[unAvailabilitySymbol];
	}

	public static addToUnAvailability(propertyValue: PropertyValue): void {
			if(!propertyValue.parent!.value[unAvailabilitySymbol]) {
				propertyValue.parent!.value[unAvailabilitySymbol] = {}
			}
			if(!Object.keys(propertyValue.parent!.value[unAvailabilitySymbol]).includes(propertyValue.property.name)) {
				propertyValue.parent!.value[unAvailabilitySymbol][propertyValue.property.name] = propertyValue.value
			}
	}

	public static removeFromUnAvailability(propertyParentTuple: PropertyParentTuple): any | undefined {
		let value;
		let unAvailable = ModelSystemProperties.getUnAvailablity(propertyParentTuple);
		if(Object.keys(unAvailable).includes(propertyParentTuple.property.name)) {
			value = unAvailable[propertyParentTuple.property.name];
			delete unAvailable[propertyParentTuple.property.name];
		}
		return value;
	}
	public static isAvailable(propertyParentTuple: PropertyParentTuple) : boolean {
		return !Object.keys(ModelSystemProperties.getUnAvailablity(propertyParentTuple)).includes(propertyParentTuple.property.name);
	}

	public static getTypeRef(model: PModel): TypeReference {
		return (model as any)[typeSymbol];
	}

	public static getExplicitType(model: any): TypeReference {
		return model._type;
	}
}
